import React, { Component } from 'react'
import SelectItemList from '../SelectItemList/SelectItemList';
import SelectTagList from '../SelectTagList/SelectTagList';
import './styles.sass';
import 'array-flat-polyfill';
import 'ie-array-find-polyfill';

export default class MultiSelect extends Component {

  constructor(props) {
      super(props)

      this.state = {
          open: false,
          itemSelected: [],
          tagSelected:[],
          masterSelected: []
      }
  }

  handleItemSelection = (items, index, multiSelectIndex) => {
    this.props.handleItemSelection(items, index, multiSelectIndex)

    if (this.props.orario != undefined){
      this.handleClick( false )
    }

  }

  handleMasterSelection = (items, index, masterChecked, multiSelectIndex) => {
    this.props.handleMasterSelection(items, index, masterChecked, multiSelectIndex);
  }

  handleClick = (open) => {
    const { callbackOpen, index, callbackApplyFilter } = this.props
    
    if(callbackOpen) callbackOpen(index, open)
    if (!open && callbackApplyFilter)
      callbackApplyFilter(index, false)
  }

  handleApplyFilter = () => {
    const { callbackApplyFilter, callbackOpen, index } = this.props
    if (callbackApplyFilter) callbackApplyFilter(index, false)
  }

  getSelectedTab = () => {
    let arrayTag = []
    let arrayGroupTag = []
    const { itemSelected} = this.props;
    const { itemsList } = this.props

    itemsList.options.map((group, index) => {
      arrayTag = []
      group.items.map((item, index) => {
        //console.log(">>>>>>TUTTO: "+ group.category+ "lunghezza: "+group.items.length)
        //console.log(">>>>>>SELEZIONATI: " + index + " ------   " + itemSelected[index] != undefined ? itemSelected[index] : "null")
        if(itemSelected.flat().indexOf(item.id) > -1) {
          arrayTag.push(item)
        }
      })
      arrayGroupTag.push(arrayTag)
    })
    
    return  arrayGroupTag;
  }


  render() {
    const { itemSelected, tagSelected, masterSelected } = this.props;
    const { type, itemsList, orario, open, index, smallSelect, labelSelection,timeTxt, labels } = this.props
    //console.log('flast',(this.getSelectedTab().flat().length == 1 ? this.getSelectedTab().flat()[0].label : "Sedi ("+this.getSelectedTab().flat().length+")"))

    const multiSelectIndex = index;
   if (!itemSelected || !masterSelected) return <div></div> 
   else {
    return (
      <div className="wrapper-multiselect">
        <div className={`${open ? 'open': ''} velina`}  onClick={ () => this.handleApplyFilter()}></div>
        <div className={`${smallSelect ? 'small': ''} close-select`} onClick={() => this.handleClick( true )}>
          <div className="label-select">{itemsList.name}</div>
          <div className="item-selected">
            {this.getSelectedTab().flat().length==0 ? itemsList.labelNoItemSelected : (this.getSelectedTab().flat().length == 1 ? this.getSelectedTab().flat()[0].label : itemsList.labelMultiSelected + " ("+this.getSelectedTab().flat().length+")")}
          </div>
        </div>
        <div className={`${open ? 'open': ''} ${smallSelect ? 'small': ''} multi-select`} >
          <SelectTagList labels={labels} tags={this.getSelectedTab()} smallSelect={smallSelect}  multiSelectIndex={multiSelectIndex} name={itemsList.name} labelSelection={labelSelection} callbackRemoveTag={this.props.removeTagSelected}/>
          <div className="select-item-all" >
            { 
              itemSelected && masterSelected && itemsList.options.map((item, index) => {
                return <SelectItemList handleMasterSelection={this.handleMasterSelection} multiSelectIndex={multiSelectIndex} masterChecked={masterSelected[index]} checkedList={itemSelected[index]}  key={index} index={index} timeTxt={timeTxt} orario={orario} callbackHour={this.props.callbackHour} itemSelectedList={itemSelected[index]} itemsList={item} callback={(items, index) => this.handleItemSelection(items, index, multiSelectIndex)} type={type}/>
              })
            }
          </div>
          { 
            !orario ?
              <div className="cta-button"><button onClick={ () => this.handleApplyFilter()}>{labels.filtersBox_dropdown_submit}</button></div>
            : <></>
          }
        </div>
      </div>
    )
        }

  }
}